function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 5.414L9.414 4l11.742 11.742L9.38 26.447l-1.346-1.48 10.224-9.294z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMzAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTggNS40MTQyMTM1NiAxLjQxNDIxMzU2LTEuNDE0MjEzNTYgMTEuNzQxNTc5NzQgMTEuNzQxNTc5OC0xMS43NzYwMTM3MiAxMC43MDU0NjcxLTEuMzQ1MzQ1NTktMS40Nzk4ODAyIDEwLjIyMzk4NjIxLTkuMjk0NTMyOXoiIC8+PC9zdmc+";
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/assets/svg/icon-arrow.svg